export default __webpack_public_path__ + "img/all_structure.5bbe3120.jpg";